export enum CONTENT_ADMIN {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=518117304
     */
    ALL_CONTENT = 'CONTENT.ALL_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=523157059
     */
    ALL_CONTENT_SELECTED = 'CONTENT_ADMIN.ALL_CONTENT_SELECTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=601229447
     */
    ALL_CONTENT_UPDATED = 'CONTENT_ADMIN.ALL_CONTENT_UPDATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=533486848
     */
    ANOTHER_BULK_ACTION_IN_PROGRESS_DESCRIPTION = 'CONTENT_ADMIN.ANOTHER_BULK_ACTION_IN_PROGRESS_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=533486610
     */
    ANOTHER_BULK_ACTION_IN_PROGRESS_TITLE = 'CONTENT_ADMIN.ANOTHER_BULK_ACTION_IN_PROGRESS_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532673092
     */
    BULK_DONE = 'CONTENT_ADMIN.BULK_DONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532659887
     */
    BULK_ERROR = 'CONTENT_ADMIN.BULK_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532659874
     */
    BULK_IN_PROGRESS = 'CONTENT_ADMIN.BULK_IN_PROGRESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=601154959
     */
    BULK_OPERATION_DETAILS_TITLE = 'CONTENT_ADMIN.BULK_OPERATION_DETAILS_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532260394
     */
    BULK_STARTED_BY_SOMEONE = 'CONTENT_ADMIN.BULK_STARTED_BY_SOMEONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=601214659
     */
    BULK_UPDATE_COMPLETED = 'CONTENT_ADMIN.BULK_UPDATE_COMPLETED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=601598294
     */
    BULK_UPDATE_COMPLETED_WITH_ERRORS = 'CONTENT_ADMIN.BULK_UPDATE_COMPLETED_WITH_ERRORS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532218335
     */
    CHANGES_MAY_TAKE_A_FEW_MINUTES = 'CONTENT_ADMIN.CHANGES_MAY_TAKE_A_FEW_MINUTES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532220449
     */
    CHANGES_OVERVIEW = 'CONTENT_ADMIN.CHANGES_OVERVIEW',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532288917
     */
    CHANGES_OVERVIEW_AUTHOR = 'CONTENT_ADMIN.CHANGES_OVERVIEW_AUTHOR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=536812128
     */
    CHANGES_OVERVIEW_EXPIRATION_DATE = 'CONTENT_ADMIN.CHANGES_OVERVIEW_EXPIRATION_DATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540627240
     */
    CONFIRM_ARCHIVE = 'CONTENT_ADMIN.CONFIRM_ARCHIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=564117196
     */
    CONFIRM_ARCHIVE_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_ARCHIVE_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=530839609
     */
    CONFIRM_CHANGES = 'CONTENT_ADMIN.CONFIRM_CHANGES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=694492370
     */
    CONFIRM_DELETE = 'CONTENT_ADMIN.CONFIRM_DELETE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=694492112
     */
    CONFIRM_DELETE_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_DELETE_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=537656580
     */
    CONFIRM_PUBLISH = 'CONTENT_ADMIN.CONFIRM_PUBLISH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=564109440
     */
    CONFIRM_PUBLISH_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_PUBLISH_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540554292
     */
    CONFIRM_UNARCHIVE = 'CONTENT_ADMIN.CONFIRM_UNARCHIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=564124499
     */
    CONFIRM_UNARCHIVE_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_UNARCHIVE_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=537656077
     */
    CONFIRM_UNPUBLISH = 'CONTENT_ADMIN.CONFIRM_UNPUBLISH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=564101422
     */
    CONFIRM_UNPUBLISH_MULTIPLE = 'CONTENT_ADMIN.CONFIRM_UNPUBLISH_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=601598808
     */
    COUNT_CONTENT_NOT_UPDATED_DUE_TO_ERROR = 'CONTENT_ADMIN.COUNT_CONTENT_NOT_UPDATED_DUE_TO_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=530485220
     */
    DISABLED_INLINE_ACTION_TOOLTIP = 'CONTENT_ADMIN.DISABLED_INLINE_ACTION_TOOLTIP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=533475153
     */
    DISABLED_WHILE_RUNNING_TOOLTIP = 'CONTENT_ADMIN.DISABLED_WHILE_RUNNING_TOOLTIP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=602311498
     */
    ERROR_IN_CONTENT_UPDATE = 'CONTENT_ADMIN.ERROR_IN_CONTENT_UPDATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=602312162
     */
    ERROR_IN_CONTENT_UPDATE_DESCRIPTION = 'CONTENT_ADMIN.ERROR_IN_CONTENT_UPDATE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=533218889
     */
    ERROR_IN_EDITING_OPTIONS = 'CONTENT_ADMIN.ERROR_IN_EDITING_OPTIONS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=533218917
     */
    ERROR_IN_EDITING_OPTIONS_DESCRIPTION = 'CONTENT_ADMIN.ERROR_IN_EDITING_OPTIONS_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=555603593
     */
    EXPIRATION_DATE_AFTER = 'CONTENT_ADMIN.EXPIRATION_DATE_AFTER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=555950854
     */
    EXPIRATION_DATE_AFTER_ACTIVE = 'CONTENT_ADMIN.EXPIRATION_DATE_AFTER_ACTIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=555611308
     */
    EXPIRATION_DATE_BEFORE = 'CONTENT_ADMIN.EXPIRATION_DATE_BEFORE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=555948357
     */
    EXPIRATION_DATE_BEFORE_ACTIVE = 'CONTENT_ADMIN.EXPIRATION_DATE_BEFORE_ACTIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=544858362
     */
    EXPIRATION_DATE_DATE_TOO_OLD_ERROR = 'CONTENT_ADMIN.EXPIRATION_DATE_DATE_TOO_OLD_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=536780811
     */
    EXPIRATION_DATE_FIELD_HELPER = 'CONTENT_ADMIN.EXPIRATION_DATE_FIELD_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=555603253
     */
    EXPIRATION_DATE_ON = 'CONTENT_ADMIN.EXPIRATION_DATE_ON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=555978729
     */
    EXPIRATION_DATE_ON_ACTIVE = 'CONTENT_ADMIN.EXPIRATION_DATE_ON_ACTIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=546736086
     */
    EXPIRATION_TIME = 'CONTENT_ADMIN.EXPIRATION_TIME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=528919815
     */
    EXPIRES_IN_DATE = 'CONTENT_ADMIN.EXPIRES_IN_DATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=523835825
     */
    EXPIRES_ON_DATE = 'CONTENT_ADMIN.EXPIRES_ON_DATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=546834057
     */
    EXPLAIN_ARCHIVE = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540627266
     */
    EXPLAIN_ARCHIVE_MULTIPLE = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540627279
     */
    EXPLAIN_ARCHIVE_ONE = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=565262007
     */
    EXPLAIN_ARCHIVE_WITH_CONTENT_NAME = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE_WITH_CONTENT_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=694494891
     */
    EXPLAIN_DELETE = 'CONTENT_ADMIN.EXPLAIN_DELETE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540238250
     */
    EXPLAIN_PUBLISH_MULTIPLE = 'CONTENT_ADMIN.EXPLAIN_PUBLISH_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540238393
     */
    EXPLAIN_PUBLISH_ONE = 'CONTENT_ADMIN.EXPLAIN_PUBLISH_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540554726
     */
    EXPLAIN_UNARCHIVE_MULTIPLE = 'CONTENT_ADMIN.EXPLAIN_UNARCHIVE_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540554629
     */
    EXPLAIN_UNARCHIVE_ONE = 'CONTENT_ADMIN.EXPLAIN_UNARCHIVE_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540213722
     */
    EXPLAIN_UNPUBLISH_MULTIPLE = 'CONTENT_ADMIN.EXPLAIN_UNPUBLISH_MULTIPLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540218486
     */
    EXPLAIN_UNPUBLISH_ONE = 'CONTENT_ADMIN.EXPLAIN_UNPUBLISH_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=661934541
     */
    FILTER_BY_INACTIVE_AUTHOR = 'CONTENT_ADMIN.FILTER_BY_INACTIVE_AUTHOR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=541651151
     */
    INCOMPATIBLE_ACTION = 'CONTENT_ADMIN.INCOMPATIBLE_ACTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532255290
     */
    MULTIPLE_CONTENT_UPDATED = 'CONTENT_ADMIN.MULTIPLE_CONTENT_UPDATED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=524511039
     */
    NO_CONTENT_MESSAGE = 'CONTENT_ADMIN.NO_CONTENT_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=524500748
     */
    NO_CONTENT_TITLE = 'CONTENT_ADMIN.NO_CONTENT_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=524173326
     */
    NUMBER_CONTENT = 'CONTENT_ADMIN.NUMBER_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=527080831
     */
    NUMBER_CONTENT_OUT_OF_MANY = 'CONTENT_ADMIN.NUMBER_CONTENT_OUT_OF_MANY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=527080956
     */
    NUMBER_CONTENT_OUT_OF_MANY_SELECTED = 'CONTENT_ADMIN.NUMBER_CONTENT_OUT_OF_MANY_SELECTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=523160370
     */
    NUMBER_CONTENT_SELECTED = 'CONTENT_ADMIN.NUMBER_CONTENT_SELECTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532260230
     */
    ONLY_ONE_BULK = 'CONTENT_ADMIN.ONLY_ONE_BULK',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532275226
     */
    REFRESH_TO_CHECK_STATUS = 'CONTENT_ADMIN.REFRESH_TO_CHECK_STATUS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=530408160
     */
    SELECT_A_PERSON = 'CONTENT_ADMIN.SELECT_A_PERSON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=609794523
     */
    SOME_CHANGES_MAY_BE_IGNORED = 'CONTENT_ADMIN.SOME_CHANGES_MAY_BE_IGNORED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540213650
     */
    SOME_CONTENT_MAY_BE_IGNORED = 'CONTENT_ADMIN.SOME_CONTENT_MAY_BE_IGNORED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540627366
     */
    TO_REVERSE_ARCHIVE = 'CONTENT_ADMIN.TO_REVERSE_ARCHIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540239547
     */
    TO_REVERSE_PUBLISH = 'CONTENT_ADMIN.TO_REVERSE_PUBLISH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540213694
     */
    TO_REVERSE_UNPUBLISH = 'CONTENT_ADMIN.TO_REVERSE_UNPUBLISH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=532257087
     */
    UNABLE_TO_UPDATE_MUTIPLE_CONTENT = 'CONTENT_ADMIN.UNABLE_TO_UPDATE_MUTIPLE_CONTENT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452686
     */
    UNPUBLISH = 'CONTENT_SET_TO_DRAFT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=601617839
     */
    UPDATING_CONTENT = 'CONTENT_ADMIN.UPDATING_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=637724351
     */
    VALUE_CANNOT_BE_SIMILAR_IN_BOTH_FIELDS = 'CONTENT_ADMIN.VALUE_CANNOT_BE_SIMILAR_IN_BOTH_FIELDS',
    /*
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=696415425
     */
    USER_ON_BEHALF_OF = 'CONTENT_ADMIN.USER_ON_BEHALF_OF',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=696447137
     */
    BULK_AUTHOR_EDITION_HELPER = 'CONTENT_ADMIN.BULK_AUTHOR_EDITION_HELPER',
}
